import React, { useState, useEffect } from "react";
import "./manageAccount.scss";
import userActivePage from "../../../store/userActivePage";
import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  TextField,
  useMediaQuery,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import authStore from "../../../store/authStore";
import { useNavigate } from "react-router-dom";
import snackbarStore from "../../../store/snackbarStore";
import SnackbarAlert from "../../../components/snackbarAlert/snackbarAlert";

// Date Picker
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Date Picker

const ManageAccount = () => {
  const navigate = useNavigate();
  const UserActivePage = userActivePage();
  const AuthStore = authStore();
  const SnackbarStore = snackbarStore();
  const isMobile = useMediaQuery("(max-width: 600px)");

  const [isLoading, setIsLoading] = useState(false);
  const [isChangePhoneLoading, setIsChangePhoneLoading] = useState(false);

  const [maxDate, setMaxDate] = useState(new Date());

  useEffect(() => {
    UserActivePage.setIsActive({ setPage: "manage-account" });
    window.scrollTo({ top: 0 });
    var date = new Date();
    date.setFullYear(date.getFullYear() - 8);
    setMaxDate(date);
  }, []);

  const saveChanges = async () => {
    setIsLoading(true);
    await AuthStore.updateProfile();
    setIsLoading(false);
    if (isMobile) {
      navigate(-1);
    } else {
      SnackbarStore.setMassage({ value: "Update Successfully" });
      SnackbarStore.setIsOpen({ value: true });
    }
  };

  return (
    <div className="manage-account">
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        alertVariant="filled"
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        massage={SnackbarStore.massage}
      />
      <div className="content">
        <Stack spacing={2}>
          <div className="page-title">Edit Profile</div>
          <Stack spacing={2} direction={isMobile ? "column" : "row"}>
            <TextField
              name="firstName"
              type="text"
              required
              fullWidth
              label="First Name"
              autoComplete="given-name"
              value={AuthStore.editProfileForm.firstName}
              onChange={AuthStore.fillEditProfileForm}
            />
            <TextField
              name="lastName"
              type="text"
              required
              fullWidth
              label="Last Name"
              autoComplete="family-name"
              value={AuthStore.editProfileForm.lastName}
              onChange={AuthStore.fillEditProfileForm}
            />
          </Stack>
          <TextField
            name="email"
            type="email"
            required
            fullWidth
            disabled
            value={AuthStore.myUser && AuthStore.myUser.email}
            label="Email Address"
            autoComplete="email"
          />
          <FormControl disabled required fullWidth>
            <InputLabel>Phone No</InputLabel>
            <OutlinedInput
              type="text"
              name="phoneNumber"
              label="Phone No"
              inputProps={{ inputMode: "numeric" }}
              autoComplete="contact-no"
              value={AuthStore.myUser && AuthStore.myUser.phoneNumber}
              endAdornment={
                <InputAdornment position="end">
                  <LoadingButton
                    aria-label="toggle password visibility"
                    edge="end"
                    className="btn"
                    loading={isChangePhoneLoading}
                    onClick={async () => {
                      setIsChangePhoneLoading(true);
                      await AuthStore.validEmailAndSendOTP({
                        email: AuthStore.myUser.email,
                        whereNavigate: "change-phone-no",
                      });

                      setIsChangePhoneLoading(false);
                      navigate("/verification/change-phone-no");
                    }}
                  >
                    <p>Change</p>
                  </LoadingButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl>
            <FormLabel>Gender</FormLabel>
            <RadioGroup
              name="gender"
              row
              value={AuthStore.editProfileForm.gender}
              onChange={AuthStore.fillEditProfileForm}
            >
              <FormControlLabel
                value="M"
                control={<Radio size="small" />}
                label={<p style={{ fontWeight: 500 }}>Male</p>}
              />
              <FormControlLabel
                value="F"
                control={<Radio size="small" />}
                label={<p style={{ fontWeight: 500 }}>Female</p>}
              />
            </RadioGroup>
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={[
                "DatePicker",
                "DesktopDatePicker",
                "MobileDatePicker",
              ]}
            >
              <DatePicker
                label="Date of Birth"
                maxDate={dayjs(maxDate)}
                format="DD/MM/YYYY"
                name="validityDate"
                value={AuthStore.editProfileForm.dateOfBirth}
                onChange={(value) => {
                  AuthStore.fillEditProfileFormOfBirthDate({
                    name: "dateOfBirth",
                    value,
                  });
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          <div className="btn-container">
            {isMobile && (
              <Button
                color="error"
                sx={{ mr: "10px", transition: "all 0.5s ease" }}
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
            )}

            <LoadingButton
              loading={isLoading}
              className="btn"
              style={{ background: isLoading && "#f5f5f5f5" }}
              variant="contained"
              onClick={saveChanges}
            >
              <p>Save Changes</p>
            </LoadingButton>
          </div>
        </Stack>
      </div>
    </div>
  );
};

export default ManageAccount;
